// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__27xQ5","footer":"ModalError_footer__3EzEa"};